export const SliderDefaultProp={
  minRange: 0, 
  maxRange: 0,
  steps: 5
};

export const SpecialCharactersRegex= /[^a-z0-9 ]/gi;

export const Labels = {
  AppointmentType: 'Appointment Type',
  Provider: 'Provider',
  AppointmentDate: 'Appointment Date',
  AppointmentTime: 'Appointment Time',
  Morning: 'Morning',
  Afternoon: 'Afternoon',
  Patient: 'Patient',
  ZipCode: 'Zip Code',
  Radius: 'Radius',
  Location: 'Location',
};

export const IPinfo_API = {
  URL: 'https://ipinfo.io/',
  Token: 'daad6b89b27fe5',
}
export const EntityTypes={
  provider:'provider',
  chair: 'chair',
  location: 'location'
}

export const AppointmentBookingUUID={
  appointmentTypeId: 'b49ff242-0835-4676-97c6-38a663e39bba',
  appointmentDateTime: '9326de60-8c7e-4f32-94c6-ed7ca8550494', //appointment_time on form contains both correct date and time.
  appointmentBookingProviderId: 'b263c560-9538-4b5b-841d-298732185edd',
  appointmentBookingLocationId: 'b154c914-6cf0-418e-a604-bf65c1aee3fe',
}

export const activeTabs={
  radius: 'radius',
  location: 'location'
};
export const locationNotAvailable='Locations not available.';
export const noLocationFoundMessageForAppointmentType='No locations found which support this appointment type.'
export const noLocationFoundMessage='No locations found which support this appointment type. Please increase your search radius.';
export const Defaults = {
  AppointmentType: { id: '', name: 'Select Visit Reason' },
  Provider: { id: '', displayName: 'Provider Selection' },
};

const mockAccountId = '5ea06a0484f89f5e01000079';

// TODO: fetch these from Account Service API
export const Mocks = {
  AppointmentTypes: [
    { name: 'Exam and Cleaning', duration: 60, id: 1, accountId: mockAccountId },
    { name: 'Dental Emergency', duration: 60, id: 2, accountId: mockAccountId },
    { name: 'Braces Consultation', duration: 30, id: 3, accountId: mockAccountId },
    { name: 'Implant Consultation', duration: 30, id: 4, accountId: mockAccountId },
    { name: 'Veneers Consultation', duration: 30, id: 5, accountId: mockAccountId },
  ],

  Providers: [
    { contactId: '123', externalId: '123', status: 'active', isOnlineBookingEnabled: true, displayName: 'Alan Johnson', jobTitle: 'King', email: 'alan@summitdental.com', id: 1, accountId: mockAccountId },
    { contactId: '456', externalId: '456', status: 'active', isOnlineBookingEnabled: true, displayName: 'Anne Barton', jobTitle: 'Queen', email: 'anne@summitdental.com', id: 2, accountId: mockAccountId },
    { contactId: '789', externalId: '789', status: 'active', isOnlineBookingEnabled: true, displayName: 'Patrick Garza', jobTitle: 'Jester', email: 'patrick@summitdental.com', id: 3, accountId: mockAccountId },
  ],

  AppointmentTypeProviders: [
    { appointmentTypeId: 1, providerId: 1 },
    { appointmentTypeId: 1, providerId: 3 },
    { appointmentTypeId: 2, providerId: 1 },
    { appointmentTypeId: 2, providerId: 2 },
    { appointmentTypeId: 3, providerId: 2 },
    { appointmentTypeId: 3, providerId: 3 },
    { appointmentTypeId: 4, providerId: 1 },
    { appointmentTypeId: 4, providerId: 2 },
    { appointmentTypeId: 4, providerId: 3 },
  ],

  TimeSlots: [
    [
      { hour: 9, minute: 45 },
      { hour: 11, minute: 30 },
      { hour: 13, minute: 15 },
      { hour: 14, minute: 0 },
      { hour: 14, minute: 30 },
      { hour: 15, minute: 30 },
      { hour: 16, minute: 15 },
    ],
    [
      { hour: 8, minute: 30 },
      { hour: 9, minute: 30 },
      { hour: 10, minute: 30 },
      { hour: 13, minute: 0 },
      { hour: 13, minute: 30 },
      { hour: 14, minute: 30 },
      { hour: 15, minute: 30 },
      { hour: 16, minute: 30 },
    ],
    [
      { hour: 9, minute: 0 },
      { hour: 10, minute: 15 },
      { hour: 12, minute: 0 },
      { hour: 14, minute: 0 },
      { hour: 14, minute: 30 },
      { hour: 15, minute: 0 },
      { hour: 15, minute: 30 },
      { hour: 16, minute: 30 },
    ],
  ],
};

export const PatientField = {
  "id": 6,
  "uuid": "c1f7c68c-c060-4683-9aed-84f6004e5ef3",
  "type_name": "Dropdown",
  "is_deleted": false,
  "properties": {
    "common": [
      [
        "label",
        {
          "type": "input",
          "label": "Label",
          "value": "Patient",
          "isDynamic": false
        }
      ],
      [
        "isVisible",
        {
          "type": "checkbox",
          "label": "Visible Option",
          "value": false,
          "isDynamic": true
        }
      ],
      [
        "sublabel",
        {
          "type": "input",
          "label": "Sublabel",
          "value": "",
          "isDynamic": true
        }
      ],
      [
        "placeholder",
        {
          "type": "input",
          "label": "Placeholder",
          "value": "",
          "isDynamic": true
        }
      ],
      [
        "makeRequired",
        {
          "type": "checkbox",
          "label": "Make Required",
          "value": true,
          "isDynamic": false
        }
      ],
      [
        "makeHidden",
        {
          "type": "checkbox",
          "label": "Make Hidden",
          "value": false,
          "isDynamic": false
        }
      ],
      [
        "hideLabel",
        {
          "type": "checkbox",
          "label": "Hide Label",
          "value": false,
          "isDynamic": false
        }
      ],
      [
        "readOnly",
        {
          "type": "checkbox",
          "label": "Read-Only",
          "value": false,
          "isDynamic": false
        }
      ]
    ],
    "specific": [
      [
        "placeholder",
        {}
      ],
      [
        "options",
        {
          "type": "option-group",
          "label": "Options",
          "value": []
        }
      ]
    ]
  },
  "sort_order": 6,
  "updated_at": "2020-07-29T07:31:50.810Z",
  "updated_by": "5ca516994291bf5601000078",
  "display_name": "Patient",
  "validationMessage": null
}

export const countryList = {
  US:"US",
  CA:"CA"
}

export const zipCodeMask = {
  US: /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/,
  CA : /^([A-Za-z][0-9][A-Za-z])\s*([0-9][A-Za-z][0-9])$/
}

export const zipCodeValidationMessage = {
  US: 'Invalid zip code format. Please enter 5 digits.',
  CA: 'Invalid postal code format. Please enter a postal code in the format A1A 2B2.',
  NO_LOCATION: 'No locations are available'
}
export const zipCodeLabel = {
  US: 'Zip Code',
  CA: 'Postal Code'
}

export const ZipCodeTextLength = {
  US: 5,
  CA: 7
}

export const AppointmentTimeValidationMessage = 'Please select a time for your appointment.';

export const AppointmentTimeLabel = 'Select appointment time';
